import { render, staticRenderFns } from "./ActionPlanItemsList.vue?vue&type=template&id=bc19a060&scoped=true"
import script from "./ActionPlanItemsList.vue?vue&type=script&lang=js"
export * from "./ActionPlanItemsList.vue?vue&type=script&lang=js"
import style0 from "./ActionPlanItemsList.vue?vue&type=style&index=0&id=bc19a060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc19a060",
  null
  
)

export default component.exports